import { t } from 'ttag';
import { isEmpty, isNil } from 'lodash';
import { controlTypes } from '../../screens/Control/ControlComponents/ModbusSchedule/constants';

export const hasValue = (value) => !!value || value === 0;

/** Checks the schedule's own fields (name/days-or-dates/time/at least one object) - independent of any single object's value. */
export const checkRequiredFields = ({
  scheduleName,
  tab,
  days,
  dates,
  powerOnTime,
  scheduleActionsPayload,
  scheduleCategories,
}) => {
  if (!scheduleName.trim()) {
    return { valid: false, error: t`Schedule name is required` };
  }
  if (scheduleName.length < 3 || scheduleName.length > 25) {
    return { valid: false, error: t`Schedule Name should be from 3 to 25 chars` };
  }
  if (tab === scheduleCategories.weekly && days.length === 0) {
    return { valid: false, error: t`At least one day must be selected` };
  }
  if (tab === scheduleCategories.calendar && dates.length === 0) {
    return { valid: false, error: t`At least one date must be selected` };
  }
  if (!hasValue(powerOnTime)) {
    return { valid: false, error: t`Start Time is Required` };
  }
  if (isEmpty(scheduleActionsPayload)) {
    return { valid: false, error: t`Select at least one Control object` };
  }
  return { valid: true, error: '' };
};

export const isValidValue = (obj) => {
  const { value, config, controlType } = obj;
  if (isNil(value)) {
    return false;
  }

  if (obj?.config?.customEnumVisibility) {
    return Object.prototype.hasOwnProperty.call(
      obj.config.customEnumVisibility,
      obj.value
    );
  }

  if (controlType != controlTypes.numericValue) {
    return true;
  }

  // Handle numeric values with customEnum constraints
  const numValue = Number(value);
  if (config?.customEnum) {
    const min = config?.customEnum.min;
    const max = config?.customEnum.max;
    return numValue >= min && numValue <= max;
  }

  return true;
};

export const areAllScheduleActionsValid = (actions) => {
  let error = '';
  const valid = Object.values(actions).every((obj) => {
    const ok = isValidValue(obj);
    if (!ok && !error) {
      error = t`Invalid value for ` + (obj?.label ?? obj?.config?.name);
    }
    return ok;
  });
  return { valid, error };
};
